<template>
	<Modal :title="'Saving data...'" :closeButton="false">
		<template v-slot:content>
			<div>
				<p class="pt-5 pl-3">
					Please wait. Your data is being saved.
				</p>
				<div class="d-flex justify-content-center">
					<Loading class="my-5" />
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
	import { Component, Vue, Watch } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import Modal from '@/components/Modal.vue';
	import Loading from '@/components/Loading';

	@Observer
	@Component({
		components: { Loading, Modal }
	})
	export default class MetadataSavingPopup extends Vue {}
</script>

<style scoped></style>
